import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem, Site } from '@card-software/library';
import { MasterDataService, RolesBootstrapService, SiteBootstrapService, SiteService } from '@card-software/nexus-utilities';
import _ from 'lodash';
import { MessageService } from 'primeng/api';
import { environment } from '../environments/environment';
import { MENU_ITEMS } from './app-menu';
import { UserAuthenticationService } from './services/user-authentication.service';
import { GlobalMessageUtil } from '@card-software/nexus-utilities';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  readonly environment = environment.environment;
  title = 'inventory-ui';
  isLoginPage = false;

  menuItems: MenuItem[] = MENU_ITEMS;

  constructor(
    private router: Router,
    private userAuthenticationService: UserAuthenticationService,
    private messageService: MessageService,
    private siteBootstrapService: SiteBootstrapService,
    private rolesBootstrapService: RolesBootstrapService,
  ) {
    GlobalMessageUtil.init(this.messageService);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isLoginPage = _.includes(event.url, '/login');
      }
    });
    const token = this.userAuthenticationService.getStoredJwtToken();
    if (!_.isNil(token)) {
      MasterDataService.initialize(environment.proxyUrls.itemApi, token);
      if (this.userAuthenticationService.roles.includes('InventoryReportingAdmin')) {
        console.log('Initializing Report Service API');
      } else {
        console.log('Skipping Report Service API Initialization');
      }
      this.rolesBootstrapService.initializeRoles(token);
      this.siteBootstrapService.initializeSites(token);
    }
  }

  get isLoggedIn() {
    return this.userAuthenticationService.isUserAuthenticated;
  }

  get userLite() {
    return this.userAuthenticationService.userLite;
  }

  get userToken() {
    return this.userAuthenticationService.getStoredJwtToken() || '';
  }

  get sites(): Site[] {
    return SiteService.getSites();
  }

  get selectedSiteId(): string {
    return SiteService.getSelectedSiteId() || '';
  }

  onSiteChanged(siteId: string) {
    SiteService.setSelectedSite(siteId);
  }

  onLogout() {
    this.userAuthenticationService.logout();
  }
}
